export enum AuthFlowId {
  /**
   * Обычный вход в личный кабинет
   */
  Login = 'login',
  /**
   * Регистрация
   */
  Registration = 'registration',
  /**
   * Вход по ссылке на ПВЗ
   */
  Pvz = 'pvz',
}

export enum AuthStepId {
  /**
   * Ввод email
   */
  ENTER_EMAIL = 'ENTER_EMAIL',
  /**
   * Подтверждение email
   */
  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
  /**
   * Выбор аккаунта
   */
  SELECT_ACCOUNT = 'SELECT_ACCOUNT',
  /**
   * Ввод телефона
   */
  TEL_VERIFICATION = 'TEL_VERIFICATION',
  /**
   * Анкетирование
   */
  ONBOARDING = 'ONBOARDING',
  /**
   * Ввод ссылки для сотрудника ПВЗ
   */
  ENTER_ON_PVZ_LINK = 'ENTER_ON_PVZ_LINK',
  /**
   * Ввод пинкода ПВЗ для сотрудника
   */
  ENTER_PINCODE = 'ENTER_PINCODE',
  /**
   * Ввод ссылки для сотрудника ПВЗ для неизвестного пользователя
   */
  ENTER_ON_PVZ_LINK_UNKNOWN_USER = 'ENTER_ON_PVZ_LINK_UNKNOWN_USER',
}

export enum AuthStepRoute {
  Email = 'email',
  Code = 'code',
  Accounts = 'accounts',
  Tel = 'tel',
  Onboarding = 'onboarding',
  Link = 'link',
  Pincode = 'pincode',
  Substitute = 'substitute',
}

export enum AuthTransitionKey {
  /**
   * По умолчанию
   */
  Default = 'default',
  /**
   * Есть аккаунты
   */
  HasAccounts = 'hasAccounts',
  /**
   * Нужно подтверждение телефона (meta.tel_verify.need_to_verify)
   */
  NeedTel = 'needTel',
  /**
   * Ввод пинкода ПВЗ для сотрудника
   */
  PvzPincode = 'pvzPincode',
  /**
   * Ввод ссылки для сотрудника ПВЗ для неизвестного пользователя
   */
  PvzSubstitute = 'pvzSubstitute',
}

export enum AuthFlowComplete {
  Complete = 'COMPLETE',
}
